import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import getTimeDifference from "../../../../../../Common/TimeDifference";
import DownloadwithDisplayProper from "../../../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype,
} from "../../../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeCategoryandSubcategory from "../../../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import { Modal } from "reactstrap";
import ModelGiveReview from "../../../../../../Common/ContractandPost/ModelGiveReview";
import DeadlineComponents from "../../../../../../Common/DeadlineComponents";
import ConfirmModal from "../../../../../../Common/ConfirmModal";
import { useSelector } from "react-redux";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineContestOverview({ pd, posts, cancelpost }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [review, setReview] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const navigate = useNavigate();

  const paynowforconstest = () => {
    const state = {
      id: posts?.id,
      type: 2,
      type_of_post: "contest",
      post_id: posts?.id,
      post_price: posts?.price,
      nav: "postlivepage",
    };
    navigate(`/${lan}/account/paymentmethodpage`, {
      state: { orderdetails: state },
    });
  }

  return (
    <div className="  project-details ">
      <div className="post-details">
        <div className="post-flex flex-wrap" style={{ rowGap: '10px' }}>
          <div>
            <h5>
              {decodeHtml(posts.title)} <span className="contest">{getPosttype(posts.type)}</span>
            </h5>
            <div className="dollar-sec">
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                  alt=""
                />
                {posts?.type == 2 ? "Prize" : "Budget"}: $
                {formatNumberWithCommas(posts.price)}
                {posts?.type == 3 &&
                  (posts?.hiring_type == 1 ? "/hour" : "/month")}
              </p>
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                  alt=""
                />
                {posts?.type == 2 ? (
                  <>Deadline: {getMemberSince(posts?.last_date)}</>
                ) : (
                  <>
                    <DeadlineComponents posts={posts} />
                  </>
                )}
              </p>
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                  alt=""
                />
                Posted:{getTimeDifference(posts?.created_on)}
              </p>
            </div>
          </div>
          {(posts?.is_mine == 1 && posts.proposal_count == 0 && posts?.status != 14) ? (
            <>
              <button
                onClick={() =>
                  navigate(`/${lan}/account/updatecontest/${posts?.id}`)
                }
              >
                Edit details
              </button>
              {(posts?.is_mine == 1 && posts?.status == 10) &&
                <button onClick={() => paynowforconstest()} >
                  Pay now
                </button>
              }
              <button
                onClick={() =>
                  setConfirmModal(true)
                }
              >
                Cancel
              </button>
            </>
          ) : (
            ""
          )}
        </div>
        {
          posts?.status == 14 &&
          <button   >
            It's Canceled
          </button>
        }
        <CustomeCategoryandSubcategory posts={posts} />
        <div className="lang-sec">
          <h6>Preferred language</h6>
          <p>{posts?.language_title}</p>
        </div>
        <div className="lang-sec">
          <h6>Description</h6>
          <CustomReactQuillDescription value={posts.description} />
        </div>
        <div className="lang-sec">
          <h6>Competencies and expertise</h6>
          <div className="skills-expert">
            <div className="photoshop">
              {Array.isArray(posts?.skills) &&
                posts?.skills.map((item1, index1) => (
                  <p key={index1}>{decodeHtml(item1.title)}</p>
                ))}
            </div>
          </div>
        </div>
        {Array.isArray(posts?.files) &&
          posts?.files &&
          posts?.files?.length > 0 && (
            <div className="lang-sec">
              <h6>Attachments</h6>
              <div className="images">
                {posts?.files &&
                  Array.isArray(posts?.files) &&
                  posts?.files.map((item, index) => {
                    return <DownloadwithDisplayProper item={item} />;
                  })}
              </div>
            </div>
          )}
        <div className="lang-sec">
          <h6>Deliverables</h6>
          <CustomReactQuillDescription value={posts?.deliverables} />
        </div>
        <div className="lang-sec">
          <h6 className="activity-post"> Activity on this post</h6>
          <div className="post-p">
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                alt=""
              />
              Entries: {posts?.proposal_count}
            </p>
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                alt=""
              />
              Last viewed by client:
              {getTimeDifference(posts?.last_viewed_client)}
            </p>
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                alt=""
              />
              Seen: {posts?.view_count}
            </p>
          </div>
        </div>
        <br></br>
        {posts?.status == 13 &&
          <>
            {
              pd?.post_rating > 0 ?
                <a >
                  Already Reviewed
                </a>
                :
                <a onClick={() => setReview((state) => !state)}>
                  Give Review {' '}
                  <img
                    src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                    alt=""
                  />
                </a>
            }
          </>
        }
      </div>

      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={review}
        toggle={() => setReview((state) => !state)}
      >
        <ModelGiveReview
          setReview={setReview}
          proposalmilestones={pd}
          posts={posts}
        />
      </Modal>

      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title="Confirm Cancellation"
        message={`Are you sure you want to cancel this post?`}
        confirmpopupmessage={`This action cannot be undone.
As per admin configuration, each user is allowed a limited number of cancellations. You have used ${profile?.settings?.total_cancelation || 0} out of ${profile?.settings?.max_cancelation || 0} allowed cancellations.`}
        onConfirm={() => cancelpost()}
        showConfirmModel={false}
      />
    </div>
  );
}
